var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count_timer_container",style:({
                backgroundImage: _vm.background_color
        })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_show),expression:"is_show"}],staticClass:"count_timer"},[_c('article',{staticClass:"count_timer_header"},[_c('h2',{staticClass:"description",style:({
                        fontSize: _vm.campaign_text.size + 'px',
                        color: _vm.campaign_text.color
                    }),attrs:{"id":"t_description"}},[_vm._v(" "+_vm._s(_vm.campaign_text.text)+" ")])]),_c('article',{staticClass:"count_timer_body"},[_c('div',{staticClass:"units_container"},[_c('div',{staticClass:"number",style:({
                            backgroundImage: _vm.number_color,
                            fontSize: _vm.number_size + 'px'
                        }),attrs:{"id":"t_days"}},[_vm._v(" 00 ")]),_c('div',{staticClass:"unit",style:({
                            fontSize: _vm.unit.size,
                            color: _vm.unit.color
                        }),attrs:{"id":"t_days_unit"}},[_vm._v(" 天 ")])]),_c('div',{staticClass:"symbol_container",style:({
                        marginLeft: _vm.symbol.letter_spacing + 'px',
                        marginRight: _vm.symbol.letter_spacing + 'px',
                    })},[_c('span',{staticClass:"symbol",style:({
                            fontSize: _vm.symbol.size + 'px',
                            color: _vm.symbol.color,
                            top: _vm.symbol.top + 'px'
                        })},[_vm._v(":")])]),_c('div',{staticClass:"units_container"},[_c('div',{staticClass:"number",style:({
                            backgroundImage: _vm.number_color,
                            fontSize: _vm.number_size + 'px'
                        }),attrs:{"id":"t_hours"}},[_vm._v(" 00 ")]),_c('div',{staticClass:"unit",style:({
                            fontSize: _vm.unit.size,
                            color: _vm.unit.color
                        }),attrs:{"id":"t_hours_unit"}},[_vm._v(" 時 ")])]),_c('div',{staticClass:"symbol_container",style:({
                        marginLeft: _vm.symbol.letter_spacing + 'px',
                        marginRight: _vm.symbol.letter_spacing + 'px',
                    })},[_c('span',{staticClass:"symbol",style:({
                            fontSize: _vm.symbol.size + 'px',
                            color: _vm.symbol.color,
                            top: _vm.symbol.top + 'px'
                        })},[_vm._v(":")])]),_c('div',{staticClass:"units_container"},[_c('div',{staticClass:"number",style:({
                            backgroundImage: _vm.number_color,
                            fontSize: _vm.number_size + 'px'
                        }),attrs:{"id":"t_minutes"}},[_vm._v(" 00 ")]),_c('div',{staticClass:"unit",style:({
                            fontSize: _vm.unit.size,
                            color: _vm.unit.color
                        }),attrs:{"id":"t_minutes_unit"}},[_vm._v(" 分 ")])]),_c('div',{staticClass:"symbol_container",style:({
                        marginLeft: _vm.symbol.letter_spacing + 'px',
                        marginRight: _vm.symbol.letter_spacing + 'px',
                    })},[_c('span',{staticClass:"symbol",style:({
                            fontSize: _vm.symbol.size + 'px',
                            color: _vm.symbol.color,
                            top: _vm.symbol.top + 'px'
                        })},[_vm._v(":")])]),_c('div',{staticClass:"units_container"},[_c('div',{staticClass:"number sec",style:({
                            backgroundImage: _vm.number_color,
                            fontSize: _vm.number_size + 'px'
                        }),attrs:{"id":"t_seconds"}},[_vm._v(" 00 ")]),_c('div',{staticClass:"unit",style:({
                            fontSize: _vm.unit.size,
                            color: _vm.unit.color
                        }),attrs:{"id":"t_seconds_unit"}},[_vm._v(" 秒 ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }